import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { SessionService } from '../../session.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
  standalone: false,
})
export class SignUpComponent implements OnInit {

  admin_id?: string;
  password?: string;
  comfirm_password?: string;

  editForm: FormGroup;
  adminIdControl!: FormControl;
  passwordControl!: FormControl;
  comfirmPasswordControl!: FormControl;

  currentLang: string = 'ja';

  constructor(
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.editForm = this.formBuilder.group({
      admin_id: [this.admin_id, [Validators.required, Validators.email]],
      password: [this.password, [Validators.required, Validators.minLength(10), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]*$')]],
      comfirm_password: [this.comfirm_password, [Validators.required, Validators.minLength(10), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]*$')]],
    }, {
      validator: this.checkSame,
    });
  }

  ngOnInit(): void {
    this.adminIdControl = this.editForm.get('admin_id') as FormControl;
    this.passwordControl = this.editForm.get('password') as FormControl;
    this.comfirmPasswordControl = this.editForm.get('comfirm_password') as FormControl;
    this.currentLang = this.translate.currentLang;
  }

  // パスワードと確認パスワード同一チェック
  checkSame(ac: AbstractControl) {
    const password = ac.get('password');
    const comfirm_password = ac.get('comfirm_password');
    if (!comfirm_password?.errors) {
      if (!!password && !!comfirm_password) {
        if (password.value != comfirm_password.value) {
          comfirm_password.setErrors({ checkSame: true });
        } else {
          comfirm_password?.setErrors(null);
        }
      }
    }
  }

  signup(): void {
    if (this.passwordControl.value == this.comfirmPasswordControl.value) {
      this.sessionService.signup(this.adminIdControl.value, this.passwordControl.value);
    }
  }
  //以下、フォームの記入エラー表示
  public getErrorMessageToAdminId() {
    return this.adminIdControl.hasError('required')
      ? this.translate.instant('必須項目')
    : this.adminIdControl.hasError('email')
          ? this.translate.instant('メール形式')
          : '';
  }
  public getErrorMessageToPassword() {
    return this.passwordControl.hasError('required')
      ? this.translate.instant('必須項目')
    : this.passwordControl.hasError('minlength')
          ? this.translate.instant('１０文字以上')
          : this.passwordControl.hasError('pattern')
            ? this.translate.instant('半角英小文字大文字数字をそれぞれ１種類以上含む')
            : '';
  }
  public getErrorMessageToComfirmPassword() {
    return this.comfirmPasswordControl.hasError('required')
      ? this.translate.instant('必須項目')
    : this.comfirmPasswordControl.hasError('minlength')
          ? this.translate.instant('１０文字以上')
          : this.comfirmPasswordControl.hasError('pattern')
            ? this.translate.instant('半角英小文字大文字数字をそれぞれ１種類以上含む')
            : this.comfirmPasswordControl.hasError('checkSame')
              ? this.translate.instant('パスワードが異なります')
              : '';
  }
}
